import { Sms, AddSquare, Warning2, VideoPlay, Game } from 'iconsax-react';
import RequestForm from '@components/RequestForm';
import LeoGameModal from '@components/LeoGame';
import { MODAL_ACTION } from '@enums/common';
import { REQUEST_TYPE } from '@enums/Support';
import { Modal } from 'antd';
import { useState } from 'react';
import './styles.module.scss';
import { useNavigate } from 'react-router';

const YOUTUBE_TUTORIALS_URL = 'https://www.youtube.com/playlist?list=PLAqoAzwfPp-ADeN2ZH8FR9vtOLNvfp8ZH';


function Support() {
  const navigate = useNavigate();
  
  const [isRequestFormOpen, setIsRequestFormOpen] = useState(false);
  const [isGameOpen, setIsGameOpen] = useState(false);
  const [requestType, setRequestType] = useState<REQUEST_TYPE>(
    REQUEST_TYPE.FEATURE,
  );

  const handleRequestFormClose = (_action: MODAL_ACTION) => {
    setIsRequestFormOpen(false);
  };

  const openRequestForm = (type: REQUEST_TYPE) => {
    setRequestType(type);
    setIsRequestFormOpen(true);
  };

  return (
    <>
      <Modal
        title={<span className="text-lg font-medium">Support Center</span>}
        open
        onCancel={() => navigate('/')}
        footer={null}
        centered
        className="support-modal"
        width={400}
      >
        <div className="flex flex-col">
          {/* Support Options */}
          <div className="flex flex-col space-y-1 mb-4">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                openRequestForm(REQUEST_TYPE.FEATURE);
              }}
              className="flex items-center space-x-3 px-4 py-3 hover:bg-gray-100 rounded-lg group transition-all hover:no-underline"
            >
              <AddSquare
                size="18"
                variant="Outline"
                color="currentColor"
              />
              <span className="text-gray-600 group-hover:text-gray-800 hover:no-underline">
                Request a Feature
              </span>
            </a>

            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                openRequestForm(REQUEST_TYPE.BUG);
              }}
              className="flex items-center space-x-3 px-4 py-3 hover:bg-gray-100 rounded-lg group transition-all hover:no-underline"
            >
              <Warning2
                size="18"
                variant="Outline"
                color="currentColor"
              />
              <span className="text-gray-600 group-hover:text-gray-800">
                Report a Bug
              </span>
            </a>

            <a
              href={YOUTUBE_TUTORIALS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-3 px-4 py-3 hover:bg-gray-100 rounded-lg group transition-all hover:no-underline"
            >
              <VideoPlay
                size="18"
                variant="Outline"
                color="currentColor"
              />
              <span className="text-gray-600 group-hover:text-gray-800">
                Watch Tutorials
              </span>
            </a>

            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setIsGameOpen(true);
              }}
              className="flex items-center space-x-3 px-4 py-3 hover:bg-gray-100 rounded-lg group transition-all hover:no-underline"
            >
              <Game
                size="18"
                variant="Outline"
                color="currentColor"
              />
              <span className="text-gray-600 group-hover:text-gray-800">
                Play Leo&apos;s Quest
              </span>
            </a>
          </div>
          {/* Contact Support */}
          <div className="bg-gray-100 p-4 rounded-xl ">
            <h3 className="text-sm font-medium text-gray-600 mb-4">
              Contact Support
            </h3>
            <div className="flex flex-col space-y-4">
              <a
                href="mailto:support@leoads.ai"
                className="flex items-center space-x-3 text-gray-600 hover:text-blue-500 transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Sms
                  size="18"
                  variant="Outline"
                  color="currentColor"
                />
                <span>support@leoads.ai</span>
              </a>
            </div>
          </div>
        </div>
      </Modal>

      <RequestForm
        open={isRequestFormOpen}
        type={requestType}
        onModalClosed={handleRequestFormClose}
      />

      <LeoGameModal
        open={isGameOpen}
        onClose={() => setIsGameOpen(false)}
      />
    </>
  );
}

export default Support;
